import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { htpToClient, paramsToHtp } from "@/lib/htp";

// Entry point from Horse Trailer Price « Créer un devis »: fresh quote with the trade-in pre-filled
export default function NouveauDevis() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  useEffect(() => {
    const payload = paramsToHtp(sp);
    ["fautras_draft_id", "fautras_client_id"].forEach((k) => localStorage.removeItem(k));
    let prev = {};
    try { prev = JSON.parse(localStorage.getItem("fautras_client")) || {}; } catch { prev = {}; }
    localStorage.setItem("fautras_client", JSON.stringify({ country: prev.country || "", phone_code: prev.phone_code || "+33", ...htpToClient(payload.client) }));
    sessionStorage.setItem("fautras_htp_import", JSON.stringify(payload));
    nav(`/configurer?range=${payload.fiche.type === "fourgon" ? "prosport" : "van"}&htp=1`, { replace: true });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return <div className="min-h-[50vh] flex items-center justify-center" data-testid="nouveau-devis-loading"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;
}
